import { getUserCryptoRate } from '../../api/getUserCryptoRate';
import { useCryptoRateStore } from './store';

export const actionsCreator = ({ setState }) => ({
  LOAD_CRYPTO_RATE: async (currency) => {
    setState((state) => ({
      ...state,
      isProcessing: true
    }));

    try {
      const { data } = await getUserCryptoRate({ currency });

      setState(() => ({
        cryptoRate: data,
        isRatesLoaded: true,
        isProcessing: false
      }));
    } catch (error) {
      console.error('Error loading crypto rate:', error);

      setState(() => ({
        cryptoRate: {},
        isRatesLoaded: false,
        isProcessing: false
      }));
    }
  },
  UPDATE_CRYPTO_RATE: (rates) => {
    setState(() => ({
      cryptoRate: rates,
      isRatesLoaded: true
    }));
  }
});

export const cryptoRateActions = actionsCreator(useCryptoRateStore);
